import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-auto">
      <div className="px-4 sm:px-6 py-4 bg-gray-900">
        <div className="text-center text-gray-400 text-sm">
          <p>
            © {currentYear} TeamRezy. All rights reserved. |{' '}
            <a
              href="/privacy-policy.html"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white"
            >
              Privacy
            </a>
            {' '}|{' '}
            <a
              href="/terms-of-service.html"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white"
            >
              Terms
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;